// Mock data for MBE Alert clone

export const navItems = [
  { label: 'Features', href: '#features' },
  { label: 'Bonus', href: '#bonus' },
  { label: 'FAQ', href: '#faq' },
];

export const heroAlerts = [
  {
    type: 'BUY',
    pair: 'XAU/USD',
    timeframe: 'H1',
    entry: '2412.80',
    time: 'now',
  },
  {
    type: 'SELL',
    pair: 'EUR/USD',
    timeframe: 'M30',
    entry: '1.08245',
    time: '3m ago',
  },
  {
    type: 'BUY',
    pair: 'USD/JPY',
    timeframe: 'H4',
    entry: '156.412',
    time: '18m ago',
  },
];

export const marqueeItems = [
  'Built for MBE traders',
  'Real-time delivery',
  'Pair \u00b7 Timeframe \u00b7 Entry',
  'No noise \u00b7 only valid zones',
  '5,000+ active members',
  'Available globally',
];

export const features = [
  {
    icon: 'Bell',
    title: 'Real Time Telegram Alerts',
    desc: 'Notifies you the moment an entry zone is being triggered. Not even a candle late.',
  },
  {
    icon: 'Target',
    title: 'Pair Included',
    desc: 'Every alert tells you exactly which pair is being triggered.',
  },
  {
    icon: 'Clock',
    title: 'Timeframe Included',
    desc: 'M15, M30, H1. Timeframes at a glance, no guessing.',
  },
  {
    icon: 'LineChart',
    title: 'Entry Price Visibility',
    desc: 'Know exactly when to enter.',
  },
  {
    icon: 'Layers',
    title: 'Clean Structured Format',
    desc: 'Same layout, every alert. View, decide, enter. Actions under 5 seconds.',
  },
  {
    icon: 'Coffee',
    title: 'Built for Busy Traders',
    desc: 'Made for traders with jobs, families, and a life off the chart.',
  },
  {
    icon: 'Sparkles',
    title: 'Fresh Opportunity Focus',
    desc: 'Only fresh zones, never stale bubbles you already missed.',
  },
  {
    icon: 'Workflow',
    title: 'Better Workflow, Less Stress',
    desc: 'Less screen time. More confident executions.',
  },
];

export const webinarPoints = [
  'How to read each alert without panicking',
  'How to plug it into your existing workflow',
  'How to avoid emotional, late entries',
  'Live walk-through of real bubble zone alerts',
];

export const traderImages = [
  'https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&w=400&q=80',
  'https://images.unsplash.com/flagged/photo-1579225818168-858da8667fae?crop=entropy&cs=srgb&fm=jpg&w=400&q=80',
  'https://images.pexels.com/photos/7567588/pexels-photo-7567588.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  'https://images.unsplash.com/photo-1675869940341-d495d49010b5?crop=entropy&cs=srgb&fm=jpg&w=400&q=80',
  'https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&w=400&q=80',
  'https://images.unsplash.com/flagged/photo-1579225818168-858da8667fae?crop=entropy&cs=srgb&fm=jpg&w=400&q=80',
  'https://images.pexels.com/photos/7567588/pexels-photo-7567588.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  'https://images.unsplash.com/photo-1675869940341-d495d49010b5?crop=entropy&cs=srgb&fm=jpg&w=400&q=80',
];

export const stats = [
  { value: '5,000+', label: 'Active members' },
  { value: '3', label: 'Continents' },
  { value: '24/7', label: 'Auto delivery' },
  { value: '98%', label: 'Retention' },
];

export const testimonials = [
  {
    quote: "I used to miss zones because I was at work. MBE Alert just pings me. Clean, simple. I'm not glued to my screen anymore.",
    name: 'Aiman R.',
    role: 'Swing Trader \u00b7 Malaysia',
  },
  {
    quote: 'The structured format saves me from panic entries. I see pair, TF, entry, and I decide. No emotion, no chasing.',
    name: 'Kwame O.',
    role: 'Forex Trader \u00b7 Nigeria',
  },
  {
    quote: "Honestly the workflow upgrade I didn't know I needed. Less screen time, more confidence in the setups I take.",
    name: 'Tariq H.',
    role: 'Part-time Trader \u00b7 UAE',
  },
  {
    quote: 'Used to scroll charts for hours. Now I wait for the alert. My missed setups dropped to almost zero.',
    name: 'Lina S.',
    role: 'Day Trader \u00b7 Indonesia',
  },
  {
    quote: 'It feels less like a bot and more like a teammate that taps your shoulder when it matters.',
    name: 'Daniel P.',
    role: 'Remote Trader \u00b7 South Africa',
  },
  {
    quote: 'Clean, fast, no noise. Exactly what a real MBE workflow should feel like.',
    name: 'Reza M.',
    role: 'Trader \u00b7 Iran',
  },
];

export const realityCheck = {
  old: [
    'Staring at charts for 10+ hours',
    'Missing zones while at work',
    'Reacting late, chasing the candle',
    'Emotional, rushed entries',
  ],
  new: [
    'Live in your day, alert pings you',
    'Catch zones the moment they form',
    'Clean structured info, then decide',
    'Calm, structured, on-time entries',
  ],
};

export const workflowSteps = [
  {
    step: '01',
    title: 'Stop relying on manual checking',
    desc: 'Drop the scroll. Drop the screen anxiety. Let the system watch the chart for you.',
  },
  {
    step: '02',
    title: 'Use a real-time alert system',
    desc: 'MBE Alert pings you the second a valid bubble zone forms, with pair, timeframe, and entry included.',
  },
  {
    step: '03',
    title: 'Review setup with more clarity',
    desc: 'Clean structured format. Skim, confirm, no second-guessing.',
  },
  {
    step: '04',
    title: 'Execute with more structure',
    desc: 'No emotional chase. Just calm, on-time, structured entries.',
  },
];

export const trialFeatures = [
  { value: '5 days', label: 'Full access' },
  { value: '1 webinar', label: 'Live trade walkthrough' },
  { value: '0 risk', label: 'Cancel anytime' },
];

export const getStartedSteps = [
  {
    num: '01',
    title: 'Grab your access',
    desc: "Tap Get MBE Alert Now. We open Telegram and onboard you in seconds.",
  },
  {
    num: '02',
    title: 'Connect to MBE Alert',
    desc: 'You get added to the live alert channel. Zero install, zero setup mess.',
  },
  {
    num: '03',
    title: 'Trade on time, not late',
    desc: 'Receive structured alerts during live market sessions, plus the live webinar.',
  },
];

export const faqs = [
  {
    q: 'What is MBE Alert?',
    a: 'MBE Alert is a real-time Telegram alert assistant that notifies you the moment a valid MBE bubble zone is being triggered, with pair, timeframe, and entry already structured for you.',
  },
  {
    q: 'Do I need to watch charts all day?',
    a: 'No. That is the entire point. MBE Alert watches the chart for you and pings your Telegram the moment a valid zone is being triggered, so you can stay in your day.',
  },
  {
    q: 'What information do I receive in each alert?',
    a: 'Every alert ships with the pair, the timeframe, and the entry price, in a clean structured format that takes under 5 seconds to read and act on.',
  },
  {
    q: 'Is this a signal group?',
    a: 'No. MBE Alert is not a signal group. It is a timing layer on top of the MBE system. You still decide and execute. The alert just makes sure you do not miss the moment.',
  },
  {
    q: 'Is this suitable for beginners?',
    a: 'MBE Alert is best for traders who are familiar with the MBE system. If you are new, the live webinar walks you through how to read and use each alert without panicking.',
  },
  {
    q: 'What do I get when I join?',
    a: 'Full access to the live MBE Alert channel, including all real-time alerts during market sessions and one live trade webinar.',
  },
  {
    q: 'Is the webinar included?',
    a: 'Yes. Every Tuesday at 9PM via Zoom, we run a live walkthrough showing how to use MBE Alert plus a bonus live trade. Seats are limited.',
  },
  {
    q: 'Do I need to install anything complicated?',
    a: 'Not at all. If you have Telegram, you are ready. You get added to the live alert channel in under 2 minutes. Zero install, zero setup mess.',
  },
  {
    q: 'Does MBE Alert guarantee profit?',
    a: 'No tool guarantees profit. MBE Alert is a timing layer that helps you react on time. Your judgement and risk management still drive your results.',
  },
  {
    q: 'Who is MBE Alert best for?',
    a: 'Busy MBE traders with jobs, families, and a life off the chart who want to catch valid bubble zones the moment they form, without being glued to a screen.',
  },
];
